import { FC, ReactNode } from 'react'
import { generateSrcSet } from 'project/image-proxy-web'
import SubscriptionPricing from 'components/SubscriptionPricing'
import useWindowSize from 'components/util/useWindowSize'
import { TPlanSummary } from 'common/cms-types'
import { PlanSlug } from 'common/planSlugs'
import Heading from 'components/Heading'

type Props = {
  pitchText: string | ReactNode
  subscriptionPricingClassName?: string
  plans?: TPlanSummary[]
  headerSize?: number
  cta?: ReactNode
  desktopImage?: string
  mobileImage?: string
  dimensions?: {
    desktop?: {
      width: number
      height: number
    }
    mobile?: {
      width: number
      height: number
    }
  }
}

const SalesPitchCard: FC<Props> = ({
  cta,
  desktopImage,
  dimensions,
  headerSize = 3,
  mobileImage,
  pitchText,
  plans,
  subscriptionPricingClassName,
}) => {
  const size = useWindowSize()

  return (
    <div>
      <div className='d-flex flex-column flex-lg-row align-items-center'>
        <div
          className='d-flex justify-content-center'
          style={{
            maxWidth: size.isLgOrHigher ? '60%' : '100%',
          }}
        >
          <img
            {...generateSrcSet(
              size.isLgOrHigher
                ? desktopImage || '/images/new/robot-pointing-right-vo.png'
                : mobileImage || '/images/new/robot-holding-mail-vo.png',
              dimensions?.desktop?.width || 1460,
              dimensions?.desktop?.height || 1454,
            )}
            loading='lazy'
            height={1454}
            width={1460}
            alt='robot with stickers pointing right'
            className='img-fluid object-fit-contain'
          />
        </div>
        <div
          className='d-flex flex-1 flex-column'
          style={{
            marginTop: size.isLgOrHigher ? 0 : -40,
          }}
        >
          {typeof pitchText === 'string' ? (
            <Heading
              size={headerSize}
              className='color-pink2 fw-bold fs-fluid-64-96 lh-105'
            >
              {pitchText}
            </Heading>
          ) : (
            pitchText
          )}

          {cta ? (
            cta
          ) : (
            <div className='mt-4'>
              <SubscriptionPricing
                planSummary={plans?.find((v) => v.slug === PlanSlug.SCAN_LITE)}
                className={subscriptionPricingClassName}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SalesPitchCard
